import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCWebsiteAnalytics(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 505.383 378.455">
            <g id="Website_Analytics" transform="translate(-3.73 -69.625)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="246.37"
                    cy="33.65"
                    rx="246.37"
                    ry="33.65"
                    transform="translate(11.25 380.78)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="13.81"
                    height="55.17"
                    transform="translate(425.49 102.82)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="13.81"
                    height="43.14"
                    transform="translate(445.81 114.86)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="13.81"
                    height="33.28"
                    transform="translate(466.43 124.71)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="13.81"
                    height="19.77"
                    transform="translate(485.52 138.23)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="131.72"
                    height="81.52"
                    transform="translate(41.69 103.39)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M141.61,162.34c-9.14-3.47-19.64,6.11-28.6,2.21-5.21-2.28-7.57-8.17-10.12-13.25s-7-10.44-12.61-9.85-10.31,7.2-15.82,5.61c-3.47-1-5.2-4.85-6.07-8.36s-1.48-7.38-4.12-9.84-8.17-1.81-8.58,1.78v43.22h103S144.77,163.54,141.61,162.34Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M161.44,173.86c0,.09-25,.17-55.75.17s-55.77-.08-55.77-.17,25-.17,55.77-.17S161.44,173.77,161.44,173.86Z"
                    fill="#e0e0e0"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M161.44,155c0,.09-25,.16-55.75.16s-55.77-.07-55.77-.16,25-.17,55.77-.17S161.44,154.89,161.44,155Z"
                    fill="#707272"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M161.44,136.11c0,.09-25,.17-55.75.17s-55.77-.08-55.77-.17,25-.17,55.77-.17S161.44,136,161.44,136.11Z"
                    fill="#707272"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M161.44,118.17c0,.09-25,.17-55.75.17s-55.77-.08-55.77-.17,25-.17,55.77-.17S161.44,118.08,161.44,118.17Z"
                    fill="#707272"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M429.68,134.13H120.94a9.63,9.63,0,0,0-9.64,9.64V361.84a9.63,9.63,0,0,0,9.64,9.63H239.43s7.54,29.16-15.83,41.22H334.4S308,397.8,314.8,371.47H429.68a9.63,9.63,0,0,0,9.63-9.63V143.77a9.63,9.63,0,0,0-9.63-9.64Z"
                    fill="#565656"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M278.26,348.54c3.72,6-2.1,12.57-7.42,8.38a2.318,2.318,0,0,1-.46-.52c-3.71-6,2.11-12.57,7.43-8.38A2.06,2.06,0,0,1,278.26,348.54Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="318.48"
                    height="193.44"
                    transform="translate(116.62 138.14)"
                    fill="#fafbfb"
                />
                <rect
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    width="9.35"
                    height="12.88"
                    transform="translate(388.48 287.09)"
                    fill="#e7515b"
                />
                <rect
                    id="Rectangle_8"
                    data-name="Rectangle 8"
                    width="9.35"
                    height="12.88"
                    transform="translate(388.48 287.09)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_9"
                    data-name="Rectangle 9"
                    width="9.35"
                    height="20.46"
                    transform="translate(368.73 279.5)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_10"
                    data-name="Rectangle 10"
                    width="9.35"
                    height="26.28"
                    transform="translate(347.42 273.35)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    width="9.35"
                    height="17.76"
                    transform="translate(149.85 281.86)"
                    fill="#e4e3e3"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.79">
                    <rect
                        id="Rectangle_12"
                        data-name="Rectangle 12"
                        width="9.35"
                        height="17.76"
                        transform="translate(149.85 281.86)"
                        fill="#e4e3e3"
                    />
                </g>
                <rect
                    id="Rectangle_13"
                    data-name="Rectangle 13"
                    width="9.35"
                    height="10.49"
                    transform="translate(170.15 289.13)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="9.35"
                    height="24.09"
                    transform="translate(189.02 275.88)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    width="9.35"
                    height="12.54"
                    transform="translate(208.77 287.09)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_16"
                    data-name="Rectangle 16"
                    width="9.35"
                    height="23.75"
                    transform="translate(228.18 275.88)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_17"
                    data-name="Rectangle 17"
                    width="9.35"
                    height="54.11"
                    transform="translate(247.41 245.51)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_18"
                    data-name="Rectangle 18"
                    width="9.35"
                    height="76.32"
                    transform="translate(267.46 223.3)"
                    fill="#565656"
                />
                <rect
                    id="Rectangle_19"
                    data-name="Rectangle 19"
                    width="9.35"
                    height="45.01"
                    transform="translate(287.42 254.61)"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_20"
                    data-name="Rectangle 20"
                    width="9.35"
                    height="52.42"
                    transform="translate(326.55 247.2)"
                    fill="#707272"
                />
                <rect
                    id="Rectangle_21"
                    data-name="Rectangle 21"
                    width="9.35"
                    height="68.37"
                    transform="translate(307.34 231.25)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M143.52,214h-1.46v-.69h3.73V214h-1.46v3.71h-.81Z"
                    fill="#707272"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M145.71,216.06a1.79,1.79,0,1,1,1.78,1.72,1.68,1.68,0,0,1-1.78-1.72Zm2.78,0a1,1,0,1,0-.275.74A1,1,0,0,0,148.49,216.06Z"
                    fill="#707272"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M153.32,213.08v4.66h-.76v-.44a1.38,1.38,0,0,1-1.11.48,1.72,1.72,0,0,1,0-3.43,1.35,1.35,0,0,1,1.08.45v-1.72Zm-.77,3a1.167,1.167,0,1,1,0-.02Z"
                    fill="#707272"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M157.15,215.77v2h-.74v-.41a1.17,1.17,0,0,1-1,.45c-.77,0-1.25-.42-1.25-1s.38-1,1.39-1h.87v-.05c0-.46-.28-.73-.83-.73a1.7,1.7,0,0,0-1,.33l-.31-.57a2.41,2.41,0,0,1,1.42-.41A1.256,1.256,0,0,1,157.15,215.77Zm-.78.92v-.39h-.81c-.53,0-.68.2-.68.45s.24.46.64.46a.84.84,0,0,0,.85-.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M161.24,214.39,159.67,218a1.31,1.31,0,0,1-1.3,1,1.34,1.34,0,0,1-.89-.31l.31-.58a.83.83,0,0,0,.58.24c.27,0,.44-.14.59-.47v-.13l-1.46-3.36h.82l1,2.48,1.06-2.48Z"
                    fill="#707272"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M142.82,314.76V317h-.23v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M154.92,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.53-.42.76.76,0,0,0-.61.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.75.23.75.6a.91.91,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M166.4,316.35c0,.38-.28.66-.82.66a1.17,1.17,0,0,1-.8-.28l.11-.19a1,1,0,0,0,.69.26c.37,0,.58-.17.58-.45s-.19-.44-.61-.44h-.16v-.17L166,315h-1.15v-.2h1.44v.16l-.63.8C166.16,315.74,166.4,316,166.4,316.35Z"
                    fill="#565656"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M178.09,316.41h-.41V317h-.21v-.58h-1.15v-.17l1.08-1.48h.24l-1,1.44h.89v-.52h.2v.52h.41Z"
                    fill="#565656"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M189.47,316.34c0,.38-.27.67-.81.67a1.2,1.2,0,0,1-.81-.28l.12-.19a1,1,0,0,0,.68.26c.38,0,.59-.18.59-.45s-.18-.47-.75-.47H188l.12-1.12h1.22v.2h-1l-.08.71h.29C189.21,315.67,189.47,315.94,189.47,316.34Z"
                    fill="#565656"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M201.08,316.33a.69.69,0,0,1-.76.68c-.6,0-.92-.41-.92-1.11a1.037,1.037,0,0,1,1-1.16,1,1,0,0,1,.53.12l-.09.18a.83.83,0,0,0-.43-.1c-.49,0-.8.31-.8.92v.18a.73.73,0,0,1,.69-.39.68.68,0,0,1,.78.68Zm-.22,0c0-.29-.22-.48-.57-.48a.51.51,0,0,0-.57.49c0,.25.2.48.59.48a.5.5,0,0,0,.55-.49Z"
                    fill="#565656"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M212.53,314.76v.16l-.94,2.07h-.25l.93-2h-1.16v.42h-.22v-.62Z"
                    fill="#565656"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M142.82,227v2.24h-.23v-2h-.53V227Z"
                    fill="#707272"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M143.36,228.07c0-.71.37-1.14.89-1.14s.89.43.89,1.14-.37,1.14-.89,1.14S143.36,228.78,143.36,228.07Zm1.55,0c0-.6-.27-.93-.66-.93s-.66.33-.66.93.27.93.66.93S144.91,228.67,144.91,228.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M145.44,229a.17.17,0,1,1,.17.17A.17.17,0,0,1,145.44,229Z"
                    fill="#707272"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M146.08,228.07c0-.71.37-1.14.89-1.14s.9.43.9,1.14-.38,1.14-.9,1.14S146.08,228.78,146.08,228.07Zm1.55,0c0-.6-.27-.93-.66-.93s-.66.33-.66.93.27.93.66.93S147.63,228.67,147.63,228.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M148.2,228.07c0-.71.37-1.14.89-1.14s.9.43.9,1.14-.38,1.14-.9,1.14S148.2,228.78,148.2,228.07Zm1.55,0c0-.6-.27-.93-.66-.93s-.66.33-.66.93.27.93.66.93S149.75,228.67,149.75,228.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M150.32,228.07c0-.71.37-1.14.89-1.14s.89.43.89,1.14-.37,1.14-.89,1.14S150.32,228.78,150.32,228.07Zm1.55,0c0-.6-.27-.93-.66-.93s-.66.33-.66.93.27.93.66.93.66-.33.66-.93Z"
                    fill="#707272"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M224.11,316.37c0,.4-.33.64-.87.64s-.86-.24-.86-.64a.55.55,0,0,1,.43-.55.5.5,0,0,1-.35-.49c0-.37.31-.59.78-.59s.79.22.79.59a.5.5,0,0,1-.36.49.56.56,0,0,1,.44.55Zm-.23,0c0-.28-.24-.45-.64-.45s-.63.17-.63.45.24.45.63.45S223.88,316.65,223.88,316.37Zm-.64-.63c.35,0,.56-.16.56-.4s-.22-.41-.56-.41-.55.16-.55.4S222.89,315.74,223.24,315.74Z"
                    fill="#565656"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M235.57,315.86c0,.76-.41,1.15-1,1.15a1,1,0,0,1-.53-.12l.09-.18a.87.87,0,0,0,.44.1c.48,0,.79-.31.79-.91a1.282,1.282,0,0,0,0-.19.71.71,0,0,1-.68.39.69.69,0,0,1-.76-.68.7.7,0,0,1,.77-.68C235.25,314.74,235.57,315.15,235.57,315.86Zm-.31-.45c0-.24-.21-.48-.6-.48a.49.49,0,0,0-.54.49c0,.29.22.48.56.48a.52.52,0,0,0,.58-.49Z"
                    fill="#565656"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M246,314.76V317h-.23v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M246.57,315.88c0-.72.37-1.14.89-1.14s.89.42.89,1.14S248,317,247.46,317,246.57,316.59,246.57,315.88Zm1.55,0c0-.6-.27-.93-.66-.93s-.66.33-.66.93.27.92.66.92.66-.33.66-.92Z"
                    fill="#565656"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M257.22,314.76V317H257v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M258.37,314.76V317h-.23v-2h-.52v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M268.75,314.76V317h-.23v-2H268v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M270.81,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.53-.42.76.76,0,0,0-.61.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.75.23.75.6a.91.91,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M280.13,314.76V317h-.21v-2h-.48v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M282,316.35a.65.65,0,0,1-.74.66,1,1,0,0,1-.74-.28l.11-.19a.84.84,0,0,0,.63.26c.34,0,.52-.17.52-.45s-.17-.44-.55-.44h-.14v-.17l.56-.78h-1v-.2h1.31v.16l-.58.8a.61.61,0,0,1,.62.63Z"
                    fill="#565656"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M291.78,314.76V317h-.23v-2H291v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M294.22,316.41h-.45V317h-.23v-.58h-1.26v-.17l1.18-1.48h.26l-1.15,1.44h1v-.52h.22v.52h.45Z"
                    fill="#565656"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M303.23,314.76V317H303v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M305.28,316.34c0,.38-.26.67-.81.67a1.17,1.17,0,0,1-.8-.28l.11-.19a1,1,0,0,0,.69.26c.38,0,.58-.18.58-.45s-.18-.47-.75-.47h-.48l.12-1.12h1.23v.2h-1l-.08.71h.29C305,315.67,305.28,315.94,305.28,316.34Z"
                    fill="#565656"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M314.78,314.76V317h-.23v-2H314v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M317,316.33a.69.69,0,0,1-.77.68c-.59,0-.91-.41-.91-1.11a1.032,1.032,0,0,1,1-1.16,1,1,0,0,1,.53.12l-.09.18a.87.87,0,0,0-.44-.1c-.48,0-.79.31-.79.92a1.205,1.205,0,0,0,0,.18.71.71,0,0,1,.68-.39.69.69,0,0,1,.79.68Zm-.23,0c0-.29-.22-.48-.56-.48a.52.52,0,0,0-.58.49c0,.25.21.48.59.48a.49.49,0,0,0,.55-.49Z"
                    fill="#565656"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M326.22,314.76V317H326v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M328.34,314.76v.16L327.4,317h-.25l.92-2h-1.15v.42h-.23v-.62Z"
                    fill="#565656"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M337.79,314.76V317h-.23v-2H337v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M340,316.37c0,.4-.33.64-.87.64s-.86-.24-.86-.64a.55.55,0,0,1,.43-.55.5.5,0,0,1-.35-.49c0-.37.31-.59.78-.59s.79.22.79.59a.51.51,0,0,1-.36.49A.56.56,0,0,1,340,316.37Zm-.23,0c0-.28-.24-.45-.64-.45s-.63.17-.63.45.24.45.63.45.68-.17.68-.45Zm-.64-.63c.35,0,.56-.16.56-.4s-.22-.41-.56-.41-.55.16-.55.4.24.41.59.41Z"
                    fill="#565656"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M348.58,314.76V317h-.23v-2h-.52v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M350.73,315.86c0,.76-.41,1.15-1,1.15a1,1,0,0,1-.53-.12l.09-.18a.87.87,0,0,0,.44.1c.48,0,.79-.31.79-.91a1.282,1.282,0,0,0,0-.19.71.71,0,0,1-.68.39.69.69,0,0,1-.76-.68.7.7,0,0,1,.76-.68C350.41,314.74,350.73,315.15,350.73,315.86Zm-.31-.45c0-.24-.21-.48-.6-.48a.49.49,0,0,0-.54.49c0,.29.22.48.56.48a.52.52,0,0,0,.58-.49Z"
                    fill="#565656"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M360.29,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.52-.42.77.77,0,0,0-.62.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.75.23.75.6a.91.91,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M360.56,315.88c0-.72.38-1.14.9-1.14s.89.42.89,1.14S362,317,361.46,317,360.56,316.59,360.56,315.88Zm1.55,0c0-.6-.26-.93-.65-.93s-.66.33-.66.93.27.92.66.92S362.11,316.47,362.11,315.88Z"
                    fill="#565656"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M371.08,316.79v.2h-1.57v-.16l.94-.91c.25-.25.3-.4.3-.55a.512.512,0,0,0-.53-.42.76.76,0,0,0-.61.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.74.23.74.6a.88.88,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M372,314.76V317h-.23v-2h-.53v-.2Z"
                    fill="#565656"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M381.88,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.52-.42.75.75,0,0,0-.61.25l-.17-.14a1,1,0,0,1,.8-.32c.45,0,.74.23.74.6a.91.91,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M383.7,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.53-.42.76.76,0,0,0-.61.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.75.23.75.6a.91.91,0,0,1-.37.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M392.68,316.79v.2h-1.57v-.16l.93-.91c.25-.25.3-.4.3-.55a.5.5,0,0,0-.53-.42.76.76,0,0,0-.61.25l-.16-.14a1,1,0,0,1,.79-.32c.46,0,.74.23.74.6a.9.9,0,0,1-.36.7l-.76.75Z"
                    fill="#565656"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M394.45,316.35c0,.38-.28.66-.82.66a1.17,1.17,0,0,1-.8-.28l.11-.19a1,1,0,0,0,.69.26c.37,0,.58-.17.58-.45s-.19-.44-.61-.44h-.16v-.17l.62-.78h-1.14v-.2h1.44v.16l-.63.8C394.21,315.74,394.45,316,394.45,316.35Z"
                    fill="#565656"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M398.77,311.18c0,.1-57.48.18-128.36.18S142,311.28,142,311.18s57.5-.18,128.41-.18S398.77,311.07,398.77,311.18Z"
                    fill="#565656"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M160.58,228.55a12.32,12.32,0,0,1-4.31,0,13,13,0,0,1,4.31,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M177.73,228.55a23.8,23.8,0,0,1-4.29.19,23.8,23.8,0,0,1-4.29-.19,25.641,25.641,0,0,1,4.29-.18,25.641,25.641,0,0,1,4.29.18Z"
                    fill="#707272"
                />
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M194.88,228.55a23.8,23.8,0,0,1-4.29.19,23.8,23.8,0,0,1-4.29-.19,25.641,25.641,0,0,1,4.29-.18A25.643,25.643,0,0,1,194.88,228.55Z"
                    fill="#707272"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M212,228.55a23.729,23.729,0,0,1-4.28.19,23.8,23.8,0,0,1-4.29-.19,25.641,25.641,0,0,1,4.29-.18,25.56,25.56,0,0,1,4.28.18Z"
                    fill="#707272"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M229.19,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M246.34,228.55a48.408,48.408,0,0,1-8.57,0,51.092,51.092,0,0,1,8.57,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M263.5,228.55a48.531,48.531,0,0,1-8.58,0,51.214,51.214,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M280.65,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M297.81,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M315,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M332.11,228.55a48.408,48.408,0,0,1-8.57,0,51.092,51.092,0,0,1,8.57,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M349.27,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M366.43,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M383.59,228.55a48.531,48.531,0,0,1-8.58,0,51.213,51.213,0,0,1,8.58,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M396.46,228.55a6.09,6.09,0,0,1-2.15.19,6.17,6.17,0,0,1-2.16-.19,6.63,6.63,0,0,1,2.16-.18,6.55,6.55,0,0,1,2.15.18Z"
                    fill="#707272"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M159.2,290.32a56.668,56.668,0,0,1-4.52,4.79,58.729,58.729,0,0,1-4.79,4.52,57.9,57.9,0,0,1,4.53-4.79A59.67,59.67,0,0,1,159.2,290.32Z"
                    fill="#707272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M179.44,290.48a57.532,57.532,0,0,1-4.52,4.78,57.892,57.892,0,0,1-4.79,4.53,56.869,56.869,0,0,1,4.52-4.79,58.5,58.5,0,0,1,4.79-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M218.1,290.31a57.9,57.9,0,0,1-4.53,4.79,57.534,57.534,0,0,1-4.78,4.52,57.547,57.547,0,0,1,4.52-4.78A57.909,57.909,0,0,1,218.1,290.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M159.08,282.05a59.835,59.835,0,0,1-4.53,4.79,59.674,59.674,0,0,1-4.78,4.52,56.663,56.663,0,0,1,4.52-4.79,54.933,54.933,0,0,1,4.79-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M198.51,290.45a56.867,56.867,0,0,1-4.52,4.79,60,60,0,0,1-4.79,4.53,56.867,56.867,0,0,1,4.52-4.79,60,60,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M198.39,282.18a60,60,0,0,1-4.53,4.79,54.928,54.928,0,0,1-4.79,4.52,60.989,60.989,0,0,1,4.53-4.78,56.1,56.1,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M195.47,275.88a28.322,28.322,0,0,1-3.07,3.33,26.6,26.6,0,0,1-3.33,3.07,27.062,27.062,0,0,1,3.07-3.34,27.674,27.674,0,0,1,3.33-3.06Z"
                    fill="#707272"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M276.85,290.31a56.67,56.67,0,0,1-4.52,4.79,54.922,54.922,0,0,1-4.79,4.52,122.664,122.664,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M276.73,282a58.732,58.732,0,0,1-4.52,4.79,60.708,60.708,0,0,1-4.79,4.52,113.585,113.585,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M276.73,272.82a58.737,58.737,0,0,1-4.52,4.79,58.507,58.507,0,0,1-4.79,4.52,113.584,113.584,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M276.85,263.91a57.527,57.527,0,0,1-4.52,4.78,56.1,56.1,0,0,1-4.79,4.53,56.1,56.1,0,0,1,4.53-4.79,57.546,57.546,0,0,1,4.78-4.52Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M276.73,255.63a56.867,56.867,0,0,1-4.52,4.79,62.123,62.123,0,0,1-4.79,4.53,54.927,54.927,0,0,1,4.52-4.79,60.008,60.008,0,0,1,4.79-4.53Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M276.73,246.41a56.869,56.869,0,0,1-4.52,4.79,62.124,62.124,0,0,1-4.79,4.53,54.92,54.92,0,0,1,4.52-4.79A60.006,60.006,0,0,1,276.73,246.41Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M296.61,290.31a59.985,59.985,0,0,1-4.53,4.79,54.923,54.923,0,0,1-4.79,4.52,60.981,60.981,0,0,1,4.53-4.78,56.1,56.1,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M296.48,282a58.738,58.738,0,0,1-4.52,4.79,60.707,60.707,0,0,1-4.79,4.52,113.589,113.589,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M296.48,272.82a58.732,58.732,0,0,1-4.52,4.79,58.507,58.507,0,0,1-4.79,4.52,113.594,113.594,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_88"
                    data-name="Path 88"
                    d="M296.61,263.91a61.008,61.008,0,0,1-4.53,4.78,56.108,56.108,0,0,1-4.79,4.53,58.1,58.1,0,0,1,4.53-4.79,54.93,54.93,0,0,1,4.79-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M296.48,255.63a56.862,56.862,0,0,1-4.52,4.79,62.124,62.124,0,0,1-4.79,4.53,54.927,54.927,0,0,1,4.52-4.79,60.012,60.012,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M335.82,290.31a57.9,57.9,0,0,1-4.53,4.79,57.537,57.537,0,0,1-4.78,4.52A118,118,0,0,1,335.82,290.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M335.69,282a56.67,56.67,0,0,1-4.52,4.79,58.727,58.727,0,0,1-4.79,4.52,113.589,113.589,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M335.69,272.82a113.6,113.6,0,0,1-9.31,9.31,113.589,113.589,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M335.82,263.91a58.827,58.827,0,0,1-4.53,4.78,58.826,58.826,0,0,1-4.78,4.53,54.935,54.935,0,0,1,4.52-4.79,56.674,56.674,0,0,1,4.79-4.52Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M335.69,255.63a54.927,54.927,0,0,1-4.52,4.79,59.99,59.99,0,0,1-4.79,4.53,56.877,56.877,0,0,1,4.52-4.79,62.111,62.111,0,0,1,4.79-4.53Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M335.69,247.74a56.667,56.667,0,0,1-4.52,4.79,56.667,56.667,0,0,1-4.79,4.52,113.589,113.589,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_96"
                    data-name="Path 96"
                    d="M256.71,290.31a56.663,56.663,0,0,1-4.52,4.79,56.66,56.66,0,0,1-4.79,4.52,122.667,122.667,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_97"
                    data-name="Path 97"
                    d="M256.59,282a57.892,57.892,0,0,1-4.53,4.79,59.672,59.672,0,0,1-4.78,4.52,58.514,58.514,0,0,1,4.52-4.79,56.884,56.884,0,0,1,4.79-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_98"
                    data-name="Path 98"
                    d="M256.59,272.82a57.9,57.9,0,0,1-4.53,4.79,57.535,57.535,0,0,1-4.78,4.52,58.508,58.508,0,0,1,4.52-4.79,56.878,56.878,0,0,1,4.79-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_99"
                    data-name="Path 99"
                    d="M237.76,290.31a58.735,58.735,0,0,1-4.52,4.79,58.509,58.509,0,0,1-4.79,4.52,118.006,118.006,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_100"
                    data-name="Path 100"
                    d="M237.63,282a56.672,56.672,0,0,1-4.52,4.79,58.735,58.735,0,0,1-4.79,4.52,118.011,118.011,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M234.66,275.8a27.851,27.851,0,0,1-3,3.3,26.231,26.231,0,0,1-3.3,3,27.848,27.848,0,0,1,3-3.3,25.45,25.45,0,0,1,3.3-3Z"
                    fill="#707272"
                />
                <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M256.71,263.91a57.532,57.532,0,0,1-4.52,4.78,57.894,57.894,0,0,1-4.79,4.53,56.1,56.1,0,0,1,4.53-4.79,57.546,57.546,0,0,1,4.78-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M256.71,247.33a58.5,58.5,0,0,1-4.52,4.79,58.735,58.735,0,0,1-4.79,4.52,118,118,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M256.59,255.63a56.094,56.094,0,0,1-4.53,4.79,60.994,60.994,0,0,1-4.78,4.53,54.934,54.934,0,0,1,4.52-4.79,58.106,58.106,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M316.8,290.31a56.67,56.67,0,0,1-4.52,4.79,54.923,54.923,0,0,1-4.79,4.52,122.664,122.664,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M316.68,282a57.9,57.9,0,0,1-4.53,4.79,59.669,59.669,0,0,1-4.78,4.52,113.584,113.584,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M316.68,272.82a57.9,57.9,0,0,1-4.53,4.79,57.532,57.532,0,0,1-4.78,4.52A113.6,113.6,0,0,1,316.68,272.82Z"
                    fill="#707272"
                />
                <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M316.8,263.91a57.532,57.532,0,0,1-4.52,4.78,56.1,56.1,0,0,1-4.79,4.53,56.094,56.094,0,0,1,4.53-4.79,57.546,57.546,0,0,1,4.78-4.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M316.68,255.63a56.094,56.094,0,0,1-4.53,4.79,61,61,0,0,1-4.78,4.53,54.931,54.931,0,0,1,4.52-4.79,60.007,60.007,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M316.68,246.41a56.1,56.1,0,0,1-4.53,4.79,60.994,60.994,0,0,1-4.78,4.53,54.927,54.927,0,0,1,4.52-4.79,60.009,60.009,0,0,1,4.79-4.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M316.68,238a58.823,58.823,0,0,1-4.53,4.78,58.829,58.829,0,0,1-4.78,4.53A113.6,113.6,0,0,1,316.68,238Z"
                    fill="#707272"
                />
                <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M315.09,231.25a41.224,41.224,0,0,1-3.73,4,39.735,39.735,0,0,1-4,3.73,38.869,38.869,0,0,1,3.72-4,40.6,40.6,0,0,1,4.01-3.73Z"
                    fill="#707272"
                />
                <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M276.85,237.05a56.667,56.667,0,0,1-4.52,4.79,54.932,54.932,0,0,1-4.79,4.52,118,118,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M276.73,228.78a60.708,60.708,0,0,1-4.52,4.79,60.716,60.716,0,0,1-4.79,4.52,113.6,113.6,0,0,1,9.31-9.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_115"
                    data-name="Path 115"
                    d="M273,223.3a20.941,20.941,0,0,1-2.66,2.92,21.389,21.389,0,0,1-2.91,2.65,20.339,20.339,0,0,1,2.65-2.92A21.221,21.221,0,0,1,273,223.3Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_116"
                    data-name="Path 116"
                    d="M356.82,290.65a57.9,57.9,0,0,1-4.53,4.79,57.537,57.537,0,0,1-4.78,4.52A113.594,113.594,0,0,1,356.82,290.65Z"
                    fill="#707272"
                />
                <path
                    id="Path_117"
                    data-name="Path 117"
                    d="M356.69,282.38a113.6,113.6,0,0,1-9.31,9.31A113.579,113.579,0,0,1,356.69,282.38Z"
                    fill="#707272"
                />
                <path
                    id="Path_118"
                    data-name="Path 118"
                    d="M356.64,273.21a116.679,116.679,0,0,1-9.26,9.26,116.69,116.69,0,0,1,9.26-9.26Z"
                    fill="#707272"
                />
                <path
                    id="Path_119"
                    data-name="Path 119"
                    d="M378.1,290.65a113.584,113.584,0,0,1-9.31,9.31,113.585,113.585,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_120"
                    data-name="Path 120"
                    d="M378,282.38a113.6,113.6,0,0,1-9.31,9.31,118.008,118.008,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_121"
                    data-name="Path 121"
                    d="M371.61,279.52a1.97,1.97,0,0,1-.34.53c-.25.29-.27.32-.44.5l-.27.29-.15.15-.07.07h0c-.12-.12.26.27-.27-.26h0c-.06-.06.5.5.26.27h0l-.07.08-.15.15-.29.27c-.18.17-.35.32-.5.44s-.49.38-.53.34.1-.23.34-.53l.45-.5.27-.28.14-.15.08-.08h0c-.24-.23.32.32.26.27h0c-.53-.53-.15-.14-.27-.26h0l.08-.08.15-.14.28-.27.5-.45C371.38,279.62,371.58,279.49,371.61,279.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_122"
                    data-name="Path 122"
                    d="M397.81,290.65A113.592,113.592,0,0,1,388.5,300a113.6,113.6,0,0,1,9.31-9.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_123"
                    data-name="Path 123"
                    d="M392.87,287.19a14.127,14.127,0,0,1-2.12,2.38,13.6,13.6,0,0,1-2.38,2.12,27.63,27.63,0,0,1,4.5-4.5Z"
                    fill="#707272"
                />
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M435.1,155.79c0,.1-71.3.19-159.24.19s-159.24-.09-159.24-.19,71.28-.19,159.24-.19S435.1,155.69,435.1,155.79Z"
                    fill="#707272"
                />
                <rect
                    id="Rectangle_22"
                    data-name="Rectangle 22"
                    width="66.81"
                    height="22.35"
                    rx="4.64"
                    transform="translate(163.24 177.04)"
                    fill="#707272"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M177.58,192.87l-1.87-3.17-.75.86a.71.71,0,0,1-.77.22.72.72,0,0,1-.5-.63l-.46-5.82a.71.71,0,0,1,.35-.67.7.7,0,0,1,.76,0l4.85,3a.72.72,0,0,1,.34.72.73.73,0,0,1-.51.6l-1,.31,2.22,3Zm-1.76-4.39,2,3.4,1.35-.82-2.37-3.19,2-.61-4.85-3h-.01l.45,5.81Z"
                    fill="#fff"
                />
                <g id="Group_2" data-name="Group 2" opacity="0.4">
                    <path
                        id="Path_126"
                        data-name="Path 126"
                        d="M188.17,198c-.11,0-.19-4.38-.19-9.78s.08-9.78.19-9.78.18,4.38.18,9.78S188.27,198,188.17,198Z"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_127"
                    data-name="Path 127"
                    d="M193.91,185.5v5.42h-1v-4.57h-1.15v-.85Z"
                    fill="#fff"
                />
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M195,188.21c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.79-2.27,2.79S195,190,195,188.21Zm3.51,0c0-1.31-.51-1.91-1.25-1.91s-1.25.6-1.25,1.91.51,1.91,1.25,1.91,1.24-.6,1.24-1.91Z"
                    fill="#fff"
                />
                <path
                    id="Path_129"
                    data-name="Path 129"
                    d="M200.07,190.33a.64.64,0,1,1,.292.62.64.64,0,0,1-.292-.62Z"
                    fill="#fff"
                />
                <path
                    id="Path_130"
                    data-name="Path 130"
                    d="M205.93,189.26c0,1-.69,1.74-2.14,1.74a3.37,3.37,0,0,1-2-.63l.43-.78a2.57,2.57,0,0,0,1.59.53c.72,0,1.15-.31,1.15-.82s-.34-.85-1.46-.85h-1.31l.28-2.95h3.18v.85h-2.33l-.11,1.25h.52C205.29,187.6,205.93,188.3,205.93,189.26Z"
                    fill="#fff"
                />
                <path
                    id="Path_131"
                    data-name="Path 131"
                    d="M206.51,188.21c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.79-2.27,2.79S206.51,190,206.51,188.21Zm3.52,0c0-1.31-.52-1.91-1.26-1.91s-1.25.6-1.25,1.91.52,1.91,1.25,1.91,1.23-.6,1.23-1.91Z"
                    fill="#fff"
                />
                <path
                    id="Path_132"
                    data-name="Path 132"
                    d="M211.72,188.21c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.79-2.27,2.79S211.72,190,211.72,188.21Zm3.51,0c0-1.31-.51-1.91-1.25-1.91s-1.25.6-1.25,1.91.51,1.91,1.25,1.91S215.23,189.52,215.23,188.21Z"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_23"
                    data-name="Rectangle 23"
                    width="66.81"
                    height="22.35"
                    rx="2.78"
                    transform="translate(242.21 176.96)"
                    fill="#e4e3e3"
                />
                <g id="Group_3" data-name="Group 3" opacity="0.2">
                    <rect
                        id="Rectangle_24"
                        data-name="Rectangle 24"
                        width="66.81"
                        height="22.35"
                        rx="3.41"
                        transform="translate(242.21 177.11)"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_133"
                    data-name="Path 133"
                    d="M275.4,189.44c0,1-.87,1.63-2.22,1.63s-2.21-.62-2.21-1.63a1.35,1.35,0,0,1,.87-1.29,1.24,1.24,0,0,1-.67-1.14c0-.93.81-1.51,2-1.51s2,.58,2,1.51a1.24,1.24,0,0,1-.69,1.14,1.34,1.34,0,0,1,.92,1.29Zm-1,0c0-.54-.46-.87-1.21-.87s-1.19.33-1.19.87.45.87,1.19.87,1.2-.31,1.2-.9Zm-2.23-2.35c0,.46.39.75,1,.75s1-.29,1-.75-.42-.77-1-.77-1.01.25-1.01.74Z"
                    fill="#707272"
                />
                <path
                    id="Path_134"
                    data-name="Path 134"
                    d="M276.1,190.41a.61.61,0,0,1,.63-.64.62.62,0,0,1,.64.64.63.63,0,0,1-.64.64.62.62,0,0,1-.63-.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_135"
                    data-name="Path 135"
                    d="M282,189.33c0,.95-.69,1.74-2.15,1.74a3.4,3.4,0,0,1-2-.62l.42-.78a2.63,2.63,0,0,0,1.6.53c.72,0,1.14-.32,1.14-.83s-.33-.84-1.45-.84h-1.31l.28-2.95h3.18v.84h-2.33l-.12,1.25h.52C281.32,187.67,282,188.37,282,189.33Z"
                    fill="#707272"
                />
                <path
                    id="Path_136"
                    data-name="Path 136"
                    d="M282.54,188.29c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.78-2.27,2.78S282.54,190.07,282.54,188.29Zm3.51,0c0-1.31-.51-1.92-1.25-1.92s-1.25.61-1.25,1.92.51,1.91,1.25,1.91,1.25-.6,1.25-1.91Z"
                    fill="#707272"
                />
                <path
                    id="Path_137"
                    data-name="Path 137"
                    d="M287.75,188.29c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.78-2.27,2.78S287.75,190.07,287.75,188.29Zm3.51,0c0-1.31-.51-1.92-1.25-1.92s-1.25.61-1.25,1.92.51,1.91,1.25,1.91S291.26,189.6,291.26,188.29Z"
                    fill="#707272"
                />
                <path
                    id="Path_138"
                    data-name="Path 138"
                    d="M253,193.4a.89.89,0,0,1-.47-.14.87.87,0,0,1-.37-.82l.35-2.56a.17.17,0,0,0,0-.12L250.52,188a.85.85,0,0,1,.42-1.47l2.54-.46a.12.12,0,0,0,.09-.08l1.07-2.35a.83.83,0,0,1,.74-.5.85.85,0,0,1,.78.45l1.22,2.27a.12.12,0,0,0,.1.07l2.57.28a.85.85,0,0,1,.52,1.44l-1.78,1.86a.14.14,0,0,0,0,.12l.53,2.53a.86.86,0,0,1-1.21.94l-2.36-1.1a.13.13,0,0,0-.12,0l-2.25,1.28a.78.78,0,0,1-.38.12Zm2.45-9.51h0a.13.13,0,0,0-.12.08l-1.06,2.35a.88.88,0,0,1-.63.49l-2.54.46a.163.163,0,0,0-.1.22l1.91,1.74a.85.85,0,0,1,.27.75l-.35,2.55a.131.131,0,0,0,.2.13l2.24-1.28a.85.85,0,0,1,.79,0l2.33,1.12a.13.13,0,0,0,.14,0,.12.12,0,0,0,0-.13l-.52-2.53a.82.82,0,0,1,.22-.76l1.78-1.87a.13.13,0,0,0,0-.14A.14.14,0,0,0,260,187l-2.56-.28a.87.87,0,0,1-.66-.45L255.53,184a.13.13,0,0,0-.12-.11Z"
                    fill="#707272"
                />
                <path
                    id="Path_139"
                    data-name="Path 139"
                    d="M263.5,198.06c-.1,0-.19-4.37-.19-9.77s.09-9.78.19-9.78.19,4.38.19,9.78S263.6,198.06,263.5,198.06Z"
                    fill="#707272"
                />
                <rect
                    id="Rectangle_25"
                    data-name="Rectangle 25"
                    width="66.81"
                    height="22.35"
                    rx="3.64"
                    transform="translate(321.18 177.04)"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_140"
                    data-name="Path 140"
                    d="M346.1,198c-.1,0-.18-4.38-.18-9.78s.08-9.78.18-9.78.19,4.38.19,9.78S346.21,198,346.1,198Z"
                    fill="#707272"
                />
                <path
                    id="Path_141"
                    data-name="Path 141"
                    d="M354.3,189.24a1.8,1.8,0,0,1-2,1.76c-1.48,0-2.35-.95-2.35-2.7a2.57,2.57,0,0,1,2.66-2.88,2.78,2.78,0,0,1,1.43.35l-.38.76a1.86,1.86,0,0,0-1-.26c-1,0-1.66.63-1.66,1.86h0a1.83,1.83,0,0,1,1.45-.56,1.69,1.69,0,0,1,1.85,1.67Zm-1,0c0-.57-.43-.92-1.09-.92a1,1,0,0,0-1.1.93c0,.51.41.91,1.13.91a1,1,0,0,0,1.09-.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_142"
                    data-name="Path 142"
                    d="M354.87,190.33a.63.63,0,0,1,.64-.64.62.62,0,0,1,.63.64.63.63,0,0,1-.63.65.64.64,0,0,1-.64-.65Z"
                    fill="#707272"
                />
                <path
                    id="Path_143"
                    data-name="Path 143"
                    d="M360.73,189.26c0,1-.68,1.74-2.14,1.74a3.37,3.37,0,0,1-2-.63l.43-.78a2.57,2.57,0,0,0,1.59.53c.72,0,1.15-.31,1.15-.82s-.33-.85-1.46-.85H357l.27-2.95h3.19v.85h-2.33L358,187.6h.52C360.09,187.6,360.73,188.3,360.73,189.26Z"
                    fill="#707272"
                />
                <path
                    id="Path_144"
                    data-name="Path 144"
                    d="M361.31,188.21c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.79-2.27,2.79S361.31,190,361.31,188.21Zm3.52,0c0-1.31-.51-1.91-1.26-1.91s-1.24.6-1.24,1.91.51,1.91,1.24,1.91S364.83,189.52,364.83,188.21Z"
                    fill="#707272"
                />
                <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M366.52,188.21c0-1.78,1-2.79,2.26-2.79s2.27,1,2.27,2.79-1,2.79-2.27,2.79S366.52,190,366.52,188.21Zm3.52,0c0-1.31-.51-1.91-1.26-1.91s-1.25.6-1.25,1.91.52,1.91,1.25,1.91,1.22-.6,1.22-1.91Z"
                    fill="#707272"
                />
                <path
                    id="Path_146"
                    data-name="Path 146"
                    d="M334.51,193.33a5.12,5.12,0,1,1,5.12-5.12,5.12,5.12,0,0,1-5.12,5.12Zm0-9.52a4.4,4.4,0,1,0,4.4,4.4,4.4,4.4,0,0,0-4.4-4.4Z"
                    fill="#707272"
                />
                <path
                    id="Path_147"
                    data-name="Path 147"
                    d="M334.48,191.34a.37.37,0,0,1-.27-.13L332,188.58a.35.35,0,0,1,0-.5.36.36,0,0,1,.51,0l1.87,2.27,1.72-2.39a.36.36,0,0,1,.58.42l-2,2.77a.39.39,0,0,1-.28.15Z"
                    fill="#707272"
                />
                <path
                    id="Path_148"
                    data-name="Path 148"
                    d="M334.45,191.24a.36.36,0,0,1-.36-.36v-5a.36.36,0,0,1,.72,0v5A.36.36,0,0,1,334.45,191.24Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="1.92"
                    cy="1.92"
                    r="1.92"
                    transform="translate(132.23 144.78)"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="1.92"
                    cy="1.92"
                    r="1.92"
                    transform="translate(138.92 144.78)"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="1.92"
                    cy="1.92"
                    r="1.92"
                    transform="translate(145.62 144.78)"
                    fill="#707272"
                />
                <path
                    id="Path_149"
                    data-name="Path 149"
                    d="M389.31,98.75l-.04-.01.4-1.42.04.01Z"
                    fill="#263238"
                />
                <path
                    id="Path_150"
                    data-name="Path 150"
                    d="M417.88,371.54c0,.1-63.44.19-141.67.19s-141.67-.09-141.67-.19,63.41-.19,141.67-.19S417.88,371.44,417.88,371.54Z"
                    fill="#455b64"
                />
                <rect
                    id="Rectangle_26"
                    data-name="Rectangle 26"
                    width="131.85"
                    height="60.95"
                    transform="translate(370.39 196.78)"
                    fill="#fafbfb"
                />
                <path
                    id="Path_151"
                    data-name="Path 151"
                    d="M502.24,257.74v-16.4c0-10.53,0-25.76-.07-44.56l.13.14L370.4,197h0l.19-.19v61l-.18-.18,94.67.09h27.38l-27.3.05-94.79.09h-.18V196.5h.2l131.84.05h.14v.13c0,18.84-.06,34.09-.07,44.64v15.26A9.486,9.486,0,0,1,502.24,257.74Z"
                    fill="#565656"
                />
                <path
                    id="Path_152"
                    data-name="Path 152"
                    d="M379.67,238.89v1.92h-.2v-1.75H379v-.17Z"
                    fill="#707272"
                />
                <path
                    id="Path_153"
                    data-name="Path 153"
                    d="M380.13,239.85c0-.61.32-1,.77-1s.77.37.77,1-.33,1-.77,1S380.13,240.46,380.13,239.85Zm1.33,0c0-.51-.23-.8-.56-.8s-.57.29-.57.8.23.8.57.8S381.46,240.36,381.46,239.85Z"
                    fill="#707272"
                />
                <path
                    id="Path_154"
                    data-name="Path 154"
                    d="M380.45,228.67v.18H379.1v-.14l.8-.79c.22-.21.26-.34.26-.47a.434.434,0,0,0-.45-.36.68.68,0,0,0-.53.21l-.14-.12a.89.89,0,0,1,.68-.27c.39,0,.64.19.64.52a.81.81,0,0,1-.32.6l-.65.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_155"
                    data-name="Path 155"
                    d="M380.69,227.88c0-.61.32-1,.76-1s.77.36.77,1-.32,1-.77,1S380.69,228.5,380.69,227.88Zm1.33,0c0-.51-.23-.79-.57-.79s-.56.28-.56.79.23.8.56.8.55-.28.55-.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_156"
                    data-name="Path 156"
                    d="M380.41,216.33c0,.32-.24.57-.7.57a1,1,0,0,1-.69-.25l.09-.16a.86.86,0,0,0,.6.23c.32,0,.49-.15.49-.39s-.16-.38-.52-.38h-.13v-.15l.53-.67h-1V215h1.23v.14l-.54.68C380.2,215.8,380.41,216,380.41,216.33Z"
                    fill="#707272"
                />
                <path
                    id="Path_157"
                    data-name="Path 157"
                    d="M380.69,215.92c0-.61.32-1,.76-1s.77.37.77,1-.32,1-.77,1S380.69,216.53,380.69,215.92Zm1.33,0c0-.52-.23-.8-.57-.8s-.56.28-.56.8.23.8.56.8.55-.29.55-.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_158"
                    data-name="Path 158"
                    d="M388.16,246.16c0-.61.32-1,.77-1s.77.36.77,1-.33,1-.77,1S388.16,246.78,388.16,246.16Zm1.34,0c0-.51-.23-.79-.57-.79s-.57.28-.57.79.23.8.57.8S389.5,246.68,389.5,246.16Z"
                    fill="#707272"
                />
                <path
                    id="Path_159"
                    data-name="Path 159"
                    d="M402.41,245.2v1.93h-.2v-1.75h-.45v-.18Z"
                    fill="#707272"
                />
                <path
                    id="Path_160"
                    data-name="Path 160"
                    d="M417.42,247v.18h-1.35V247l.8-.79c.22-.21.26-.34.26-.47a.434.434,0,0,0-.45-.36.68.68,0,0,0-.53.21l-.14-.12a.86.86,0,0,1,.69-.27c.39,0,.63.19.63.52a.79.79,0,0,1-.31.6l-.66.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_161"
                    data-name="Path 161"
                    d="M431.61,246.57c0,.33-.23.57-.7.57a1,1,0,0,1-.69-.24l.1-.16a.82.82,0,0,0,.59.22c.32,0,.5-.15.5-.39s-.16-.38-.52-.38h-.14v-.14l.54-.67h-1v-.18h1.24v.14L431,246C431.41,246.05,431.61,246.27,431.61,246.57Z"
                    fill="#707272"
                />
                <path
                    id="Path_162"
                    data-name="Path 162"
                    d="M446.21,246.62h-.39v.51h-.19v-.51h-1.09v-.14l1-1.28h.22l-1,1.24h.83V246h.19v.44h.39Z"
                    fill="#707272"
                />
                <path
                    id="Path_163"
                    data-name="Path 163"
                    d="M460.11,246.56c0,.33-.23.58-.7.58a1,1,0,0,1-.69-.24l.1-.16a.82.82,0,0,0,.59.22c.33,0,.5-.16.5-.39s-.15-.4-.64-.4h-.41l.1-1H460v.18h-.88l-.06.61h.24C459.89,246,460.11,246.22,460.11,246.56Z"
                    fill="#707272"
                />
                <path
                    id="Path_164"
                    data-name="Path 164"
                    d="M474.49,246.55a.6.6,0,0,1-.66.59c-.51,0-.79-.35-.79-1s.36-1,.88-1a1,1,0,0,1,.46.1l-.08.16a.65.65,0,0,0-.38-.09c-.41,0-.68.27-.68.79a.81.81,0,0,0,0,.15.61.61,0,0,1,.59-.33.59.59,0,0,1,.66.63Zm-.2,0a.42.42,0,0,0-.48-.42.45.45,0,0,0-.5.42.46.46,0,0,0,.51.42.42.42,0,0,0,.47-.41Z"
                    fill="#707272"
                />
                <path
                    id="Path_165"
                    data-name="Path 165"
                    d="M488.63,245.2v.14l-.8,1.79h-.22l.79-1.75h-1v.36h-.19v-.54Z"
                    fill="#707272"
                />
                <path
                    id="Path_166"
                    data-name="Path 166"
                    d="M488.73,239.94c0,.11-22.27.19-49.74.19s-49.75-.08-49.75-.19,22.27-.18,49.75-.18S488.73,239.84,488.73,239.94Z"
                    fill="#707272"
                />
                <path
                    id="Path_167"
                    data-name="Path 167"
                    d="M488.73,227.92c0,.1-22.27.18-49.74.18s-49.75-.08-49.75-.18,22.27-.19,49.75-.19S488.73,227.81,488.73,227.92Z"
                    fill="#707272"
                />
                <path
                    id="Path_168"
                    data-name="Path 168"
                    d="M488.73,215.89c0,.1-22.27.19-49.74.19s-49.75-.09-49.75-.19,22.27-.19,49.75-.19S488.73,215.78,488.73,215.89Z"
                    fill="#707272"
                />
                <path
                    id="Path_169"
                    data-name="Path 169"
                    d="M389.24,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_170"
                    data-name="Path 170"
                    d="M403.54,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_171"
                    data-name="Path 171"
                    d="M417.85,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M432.15,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M446.46,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M475.07,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M460.76,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M489.37,239.77a.64.64,0,1,1-.64-.64.64.64,0,0,1,.64.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M395.76,239.94a.42.42,0,0,1-.42.42.41.41,0,0,1-.42-.42.42.42,0,0,1,.84,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M410.11,239.94a.42.42,0,1,1-.187-.417.42.42,0,0,1,.187.417Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="0.42"
                    cy="0.42"
                    r="0.42"
                    transform="translate(423.63 239.52)"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="0.42"
                    cy="0.42"
                    r="0.42"
                    transform="translate(437.99 239.52)"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="0.42"
                    cy="0.42"
                    r="0.42"
                    transform="translate(452.35 239.52)"
                    fill="#707272"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M467.55,239.94a.42.42,0,1,1-.42-.42.42.42,0,0,1,.42.42Z"
                    fill="#707272"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M481.91,239.94a.42.42,0,1,1-.42-.42.42.42,0,0,1,.42.42Z"
                    fill="#707272"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M404.47,234.63a1.56,1.56,0,1,1-.457-1.113,1.57,1.57,0,0,1,.457,1.113Z"
                    fill="#707272"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M417,227.26a1.57,1.57,0,1,1-1.57-1.57,1.57,1.57,0,0,1,1.57,1.57Z"
                    fill="#707272"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M432.44,227.92a1.56,1.56,0,1,1-.457-1.113,1.57,1.57,0,0,1,.457,1.113Z"
                    fill="#707272"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M447.56,214.53A1.57,1.57,0,1,1,446,213a1.57,1.57,0,0,1,1.56,1.53Z"
                    fill="#707272"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M461.69,223a1.57,1.57,0,1,1-1.57-1.56,1.57,1.57,0,0,1,1.57,1.56Z"
                    fill="#707272"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M476,225.31a1.57,1.57,0,1,1-1.57-1.57,1.57,1.57,0,0,1,1.57,1.57Z"
                    fill="#707272"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M489.37,234.63H489a7.6,7.6,0,0,1-1.07-.15,8,8,0,0,1-3.72-1.77,7.481,7.481,0,0,1-1.83-2.37,17.531,17.531,0,0,0-1.92-3,6.3,6.3,0,0,0-3.23-2.25,4.1,4.1,0,0,0-2.14.07,5.869,5.869,0,0,0-2,1.13,36.908,36.908,0,0,0-3.3,3.78,6.73,6.73,0,0,1-2.15,1.67,4.35,4.35,0,0,1-2.83.23,3.55,3.55,0,0,1-2.15-2,13.45,13.45,0,0,1-.92-2.86,15.878,15.878,0,0,0-.86-2.9,2.25,2.25,0,0,0-.91-1.1,3.06,3.06,0,0,0-1.45-.28,24.127,24.127,0,0,0-3.14.56,10,10,0,0,1-1.66.19,3.84,3.84,0,0,1-1.69-.33,3.54,3.54,0,0,1-1.34-1.12,8.916,8.916,0,0,1-.82-1.52c-.45-1.06-.75-2.17-1.16-3.24a8.3,8.3,0,0,0-.76-1.52,2.82,2.82,0,0,0-1.24-1l-.39-.12h-.42a1.53,1.53,0,0,0-.76.16,3.17,3.17,0,0,0-1.15,1.2,14.6,14.6,0,0,0-1.32,3.29c-.35,1.15-.63,2.33-.91,3.52-.46,2-.86,3.94-1.37,5.87a27.637,27.637,0,0,1-.88,2.84,7.439,7.439,0,0,1-1.49,2.58,2,2,0,0,1-1.41.63,2.93,2.93,0,0,1-1.45-.44,6.87,6.87,0,0,1-2-2.06,24.729,24.729,0,0,1-2.45-5,11.65,11.65,0,0,0-2.74-4.41,5.16,5.16,0,0,0-4.6-1.12,7.8,7.8,0,0,0-2.19,1,15.535,15.535,0,0,0-1.91,1.39,25.356,25.356,0,0,0-3.19,3.2h0a34.258,34.258,0,0,1-4.72,3.93,23.231,23.231,0,0,1-4.84,2.62,10.67,10.67,0,0,1-4.74.79,16.582,16.582,0,0,1-3.95-.95,37.64,37.64,0,0,1-5.12-2.35c-.57-.31-1-.56-1.28-.73s-.42-.27-.42-.27l.44.23,1.3.7a41.4,41.4,0,0,0,5.14,2.26,16.631,16.631,0,0,0,3.91.91,10.54,10.54,0,0,0,4.63-.81,22.789,22.789,0,0,0,4.77-2.62,34.579,34.579,0,0,0,4.67-3.91h0a24.748,24.748,0,0,1,3.22-3.26,14.652,14.652,0,0,1,1.94-1.42,8.09,8.09,0,0,1,2.28-1,5.45,5.45,0,0,1,4.9,1.18A11.77,11.77,0,0,1,431,227.2a24.919,24.919,0,0,0,2.43,4.91,6.46,6.46,0,0,0,1.92,1.94,2.52,2.52,0,0,0,1.26.39,1.72,1.72,0,0,0,1.16-.52,7,7,0,0,0,1.39-2.45c.34-.91.61-1.85.87-2.81.5-1.91.91-3.88,1.37-5.85.27-1.2.56-2.38.91-3.55a15,15,0,0,1,1.37-3.38,3.5,3.5,0,0,1,1.29-1.33,1.87,1.87,0,0,1,.95-.2l.47.05.45.14a3.05,3.05,0,0,1,1.41,1.17,7.9,7.9,0,0,1,.8,1.59c.42,1.09.72,2.2,1.16,3.22a4.23,4.23,0,0,0,2,2.46,5.13,5.13,0,0,0,3.13.12,24.587,24.587,0,0,1,3.2-.55,3.36,3.36,0,0,1,1.62.32,2.59,2.59,0,0,1,1.06,1.26,16.572,16.572,0,0,1,.87,3,13,13,0,0,0,.89,2.79,3.21,3.21,0,0,0,1.95,1.82,4,4,0,0,0,2.62-.21,6.13,6.13,0,0,0,2.05-1.59,37.5,37.5,0,0,1,3.34-3.78A6,6,0,0,1,475,225a4.34,4.34,0,0,1,2.26-.06,6.48,6.48,0,0,1,3.34,2.35,17,17,0,0,1,1.92,3,7.62,7.62,0,0,0,1.76,2.35,8.25,8.25,0,0,0,3.64,1.8,8.939,8.939,0,0,0,1.06.18Z"
                    fill="#707272"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M404.62,207.65c0,.1-5.55.18-12.4.18s-12.41-.08-12.41-.18,5.56-.19,12.41-.19S404.62,207.54,404.62,207.65Z"
                    fill="#707272"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M111.86,393.5l.75,12.73s13,2.45,13.41,4.79l-24.48,3.41-2-19.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M104.89,405.89a.95.95,0,0,0,.61,1.8,1.07,1.07,0,0,0,.62-1.29,1,1,0,0,0-1.32-.47"
                    fill="#ebebeb"
                />
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M101.54,414.43l-.2-2,23.24-2.77s1.43.62,1.49,1.39Z"
                    fill="#ebebeb"
                />
                <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M113,406.07c0,.12-.59.23-1.15.67s-.82,1-.94.94,0-.74.68-1.27A1.48,1.48,0,0,1,113,406.07Z"
                    fill="#263238"
                />
                <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M115.68,406.89c0,.11-.46.37-.82.92s-.43,1.09-.55,1.1-.26-.67.2-1.34S115.67,406.78,115.68,406.89Z"
                    fill="#263238"
                />
                <path
                    id="Path_194"
                    data-name="Path 194"
                    d="M117.44,409.84c-.1,0-.33-.55-.08-1.23s.78-1,.84-.91-.25.48-.45,1.05S117.56,409.82,117.44,409.84Z"
                    fill="#263238"
                />
                <path
                    id="Path_195"
                    data-name="Path 195"
                    d="M112.5,403.18c0,.12-.61,0-1.28.12s-1.19.37-1.26.27.4-.57,1.2-.69S112.55,403.08,112.5,403.18Z"
                    fill="#263238"
                />
                <path
                    id="Path_196"
                    data-name="Path 196"
                    d="M112.3,400.62a2.27,2.27,0,0,1-1.23.11,5.7,5.7,0,0,1-1.33-.27c-.24-.09-.49-.19-.74-.31a1.689,1.689,0,0,1-.4-.26.51.51,0,0,1-.12-.63.67.67,0,0,1,.5-.33,1.769,1.769,0,0,1,.47,0,4.37,4.37,0,0,1,2,.83c.62.48.86.91.82.93s-.36-.3-1-.68a5,5,0,0,0-1.16-.52,5.081,5.081,0,0,0-.72-.15c-.27,0-.49,0-.55.1s0,.06,0,.13a1.12,1.12,0,0,0,.29.19c.24.12.47.22.69.31a6.68,6.68,0,0,0,1.24.34,7.141,7.141,0,0,1,1.24.21Z"
                    fill="#263238"
                />
                <path
                    id="Path_197"
                    data-name="Path 197"
                    d="M112.16,400.81a2,2,0,0,1-.44-1.17,4.23,4.23,0,0,1,0-1.36,4.7,4.7,0,0,1,.25-.78,1,1,0,0,1,.73-.7.57.57,0,0,1,.54.3,1.52,1.52,0,0,1,.17.44,2.37,2.37,0,0,1,.08.83,2.78,2.78,0,0,1-.4,1.32c-.42.69-.91.88-.93.84a8.684,8.684,0,0,0,.67-1,3,3,0,0,0,.28-1.2,2.94,2.94,0,0,0-.09-.71c-.07-.25-.19-.46-.28-.42a1.027,1.027,0,0,0-.4.44,5.284,5.284,0,0,0-.24.7,4.46,4.46,0,0,0-.12,1.26A9.138,9.138,0,0,1,112.16,400.81Z"
                    fill="#263238"
                />
                <path
                    id="Path_198"
                    data-name="Path 198"
                    d="M56.47,391.86l-2.85,15.75-5.84,11.81a1.64,1.64,0,0,0,.85,2.24h0a1.61,1.61,0,0,0,1.49-.13c2.87-1.8,13.36-8.5,13.5-9.66.17-1.35,4.1-16.42,4.1-16.42Z"
                    fill="#707272"
                />
                <path
                    id="Path_199"
                    data-name="Path 199"
                    d="M48.63,421.66l15.21-10.85-.14.66a2.41,2.41,0,0,1-.89,1.45c-1.24,1-4.7,3.56-12.64,8.62a1.62,1.62,0,0,1-1.54.12Z"
                    fill="#ebebeb"
                />
                <path
                    id="Path_200"
                    data-name="Path 200"
                    d="M61.65,406.22a1,1,0,0,0-.52,1.21.94.94,0,0,0,1.2.53.936.936,0,1,0-.76-1.7"
                    fill="#ebebeb"
                />
                <path
                    id="Path_201"
                    data-name="Path 201"
                    d="M53.61,415.54a4.92,4.92,0,0,0-1.12-1.5,4.92,4.92,0,0,0-1.74-.71c0-.05.22-.13.6-.1a2.58,2.58,0,0,1,1.35.53,2.61,2.61,0,0,1,.86,1.18C53.68,415.3,53.65,415.53,53.61,415.54Z"
                    fill="#263238"
                />
                <path
                    id="Path_202"
                    data-name="Path 202"
                    d="M52.07,417.41a9.506,9.506,0,0,0-1.26-1,10.592,10.592,0,0,0-1.49-.51,1.85,1.85,0,0,1,1.66.2C51.85,416.6,52.16,417.39,52.07,417.41Z"
                    fill="#263238"
                />
                <path
                    id="Path_203"
                    data-name="Path 203"
                    d="M56.24,413.27a17.739,17.739,0,0,0-1.83-1.61,14.592,14.592,0,0,0-2.22-1,3.63,3.63,0,0,1,2.41.72,3.68,3.68,0,0,1,1.64,1.89Z"
                    fill="#263238"
                />
                <path
                    id="Path_204"
                    data-name="Path 204"
                    d="M57.5,408.56c-.06.08-.85-.46-2-.73s-2.07-.18-2.08-.28a3.16,3.16,0,0,1,2.17-.06,3.11,3.11,0,0,1,1.91,1.07Z"
                    fill="#263238"
                />
                <path
                    id="Path_205"
                    data-name="Path 205"
                    d="M58.46,404a8.218,8.218,0,0,0-2-.81,8,8,0,0,0-2.18.09,1.5,1.5,0,0,1,.59-.33,3.58,3.58,0,0,1,3.17.53C58.34,403.7,58.49,403.93,58.46,404Z"
                    fill="#263238"
                />
                <path
                    id="Path_206"
                    data-name="Path 206"
                    d="M56.63,402.28a1.42,1.42,0,0,1,.1-.6,4.26,4.26,0,0,1,.79-1.46,1.91,1.91,0,0,1,1-.71.67.67,0,0,1,.7.29,1.07,1.07,0,0,1,.1.76,2.31,2.31,0,0,1-2.42,1.69,2.67,2.67,0,0,1-2.3-1.9.89.89,0,0,1,.11-.77.65.65,0,0,1,.73-.2,2.2,2.2,0,0,1,.92.75,4.539,4.539,0,0,1,.82,1.43,1.41,1.41,0,0,1,.13.6,7,7,0,0,0-1.13-1.87,2.21,2.21,0,0,0-.83-.63.33.33,0,0,0-.39.11.61.61,0,0,0-.05.51,2.39,2.39,0,0,0,2,1.62A2,2,0,0,0,59,400.5a.75.75,0,0,0-.05-.54.34.34,0,0,0-.38-.16,1.64,1.64,0,0,0-.82.58,6.291,6.291,0,0,0-1.12,1.9Z"
                    fill="#263238"
                />
                <path
                    id="Path_207"
                    data-name="Path 207"
                    d="M57.46,285.48c-.17,0-5.39,119.26-5.39,119.26H68l7.75-64.61,4-49.37L88.05,337l10,65.78,16-3.44L103.2,281.84,80.5,269.21Z"
                    fill="#565656"
                />
                <path
                    id="Path_208"
                    data-name="Path 208"
                    d="M71,201l15.08-1.21c.09-1.76,0-8.57,0-8.57s6.28-1,6.35-7.24-1-20.67-1-20.67h0A21.78,21.78,0,0,0,69.49,166l-.93.72Z"
                    fill="#e4e3e3"
                />
                <g id="Group_4" data-name="Group 4" opacity="0.5">
                    <path
                        id="Path_209"
                        data-name="Path 209"
                        d="M86.06,191.08a14.53,14.53,0,0,1-8.18-2.32s1.93,4.51,8.19,4Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_210"
                    data-name="Path 210"
                    d="M69.33,173.22c-.11,0-4.31-1.27-4.17,3s4.41,3.27,4.41,3.15S69.33,173.22,69.33,173.22Z"
                    fill="#e4e3e3"
                />
                <g id="Group_5" data-name="Group 5" opacity="0.5">
                    <path
                        id="Path_211"
                        data-name="Path 211"
                        d="M68.21,177.79a1.014,1.014,0,0,1-.19.12.74.74,0,0,1-.56,0,1.85,1.85,0,0,1-.91-1.63,2.7,2.7,0,0,1,.17-1.08.9.9,0,0,1,.55-.59.39.39,0,0,1,.45.19c.06.12,0,.21.06.21s.09-.07,0-.25a.49.49,0,0,0-.17-.26.59.59,0,0,0-.42-.1,1.07,1.07,0,0,0-.76.69,2.64,2.64,0,0,0-.22,1.21,1.94,1.94,0,0,0,1.15,1.81.82.82,0,0,0,.68-.13C68.21,177.9,68.23,177.8,68.21,177.79Z"
                        fill="#707272"
                    />
                </g>
                <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M90.12,173.52a.9.9,0,0,1-.86.91.86.86,0,0,1-.92-.81.89.89,0,0,1,.86-.9.85.85,0,0,1,.92.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_213"
                    data-name="Path 213"
                    d="M90.2,172.08c-.11.12-.79-.39-1.76-.38s-1.67.48-1.77.36.06-.26.37-.48a2.42,2.42,0,0,1,1.42-.44,2.33,2.33,0,0,1,1.4.45C90.15,171.82,90.25,172,90.2,172.08Z"
                    fill="#707272"
                />
                <path
                    id="Path_214"
                    data-name="Path 214"
                    d="M80.75,173.52a.9.9,0,0,1-.86.91.87.87,0,0,1-.93-.81.9.9,0,0,1,.87-.9.85.85,0,0,1,.92.8Z"
                    fill="#707272"
                />
                <path
                    id="Path_215"
                    data-name="Path 215"
                    d="M80.73,172.26c-.12.12-.79-.39-1.76-.38s-1.67.48-1.77.36.06-.26.37-.48a2.42,2.42,0,0,1,1.42-.44,2.29,2.29,0,0,1,1.39.45C80.68,172,80.78,172.21,80.73,172.26Z"
                    fill="#707272"
                />
                <path
                    id="Path_216"
                    data-name="Path 216"
                    d="M84.22,179.41a6.31,6.31,0,0,1,1.57-.29c.24,0,.48-.07.52-.24a1.25,1.25,0,0,0-.17-.73l-.72-1.87a32.512,32.512,0,0,1-1.64-4.9,31.55,31.55,0,0,1,2,4.76L86.5,178a1.37,1.37,0,0,1,.13,1,.64.64,0,0,1-.4.36,1.7,1.7,0,0,1-.42.05,6.44,6.44,0,0,1-1.59,0Z"
                    fill="#707272"
                />
                <path
                    id="Path_217"
                    data-name="Path 217"
                    d="M81.39,180.07c.15,0,.16,1,1,1.78s2,.63,2,.78-.25.2-.72.21a2.54,2.54,0,0,1-1.68-.59,2.22,2.22,0,0,1-.82-1.49C81.2,180.33,81.32,180.07,81.39,180.07Z"
                    fill="#707272"
                />
                <path
                    id="Path_218"
                    data-name="Path 218"
                    d="M81,168.48c-.09.27-1,.14-2.18.28s-2.05.44-2.2.21.09-.36.46-.62a3.67,3.67,0,0,1,1.63-.56,3.55,3.55,0,0,1,1.71.2C80.81,168.15,81,168.36,81,168.48Z"
                    fill="#707272"
                />
                <path
                    id="Path_219"
                    data-name="Path 219"
                    d="M89.84,169.29c-.17.22-.83,0-1.63,0s-1.47.15-1.63-.08,0-.33.34-.54a2.33,2.33,0,0,1,1.32-.36,2.28,2.28,0,0,1,1.3.44C89.83,169,89.92,169.18,89.84,169.29Z"
                    fill="#707272"
                />
                <path
                    id="Path_220"
                    data-name="Path 220"
                    d="M94.44,159.3a2.3,2.3,0,0,0-.86-2.07,1.64,1.64,0,0,0-2.12.16,1.91,1.91,0,0,0-1.65-2.32c-1-.07-1.89.71-2.88,1a4.72,4.72,0,0,1-2.93-.34c-.93-.37-1.8-.89-2.74-1.23A8,8,0,0,0,71,159.18a3.59,3.59,0,0,0-3.78,1.43,5.88,5.88,0,0,0-.89,4.12,12.62,12.62,0,0,0,.72,2.81q0,.12,0,.24c.06,3.45.45,7.5,1.93,7.52,2.56,0,2-4.79,2-4.79,3.15-1.22,2-5.93,2.76-6.64s2.43-2.38,9,1a12.83,12.83,0,0,0,7.82.84h.16a6.15,6.15,0,0,0,1.69-.72,3.31,3.31,0,0,0,1.39-1.55,1.82,1.82,0,0,0-.35-2,4.08,4.08,0,0,0,.99-2.14Z"
                    fill="#565656"
                />
                <path
                    id="Path_221"
                    data-name="Path 221"
                    d="M128.66,250.65a.839.839,0,0,1,.16.17,3.1,3.1,0,0,1,.25,2.89,52.86,52.86,0,0,1-2.07,5.21s.5,2.15,0,2.65-8.68,0-8.68,0-1.4-.79-.33-1.47h5.75"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_222"
                    data-name="Path 222"
                    d="M55.15,203.92s-7.07,2.25-10.37,16.21c-2.42,10.24-9.27,30.64-7.54,33.89,2.16,4,27.16,10.48,27.16,10.48l2.12-9.5L54,246.47l6.71-22.67S61.47,205,55.15,203.92Z"
                    fill="#707272"
                />
                <path
                    id="Path_223"
                    data-name="Path 223"
                    d="M57.14,230c0,1.07,3.18,22.35,3.18,22.35L54,286.89l24.52,1.3,2.73-14.92,3.38,14.92,22.06-5.37L101,259.23l2.14-30.34-2.37-25.2-9.06-3.09-4.68-5.48-7.57,4.72-9.34-5.6-3,4-12,5.64C54,206.12,57.14,230,57.14,230Z"
                    fill="#707272"
                />
                <path
                    id="Path_224"
                    data-name="Path 224"
                    d="M70.15,194.24,69.84,201l12.9,34.3L88,201.55l-1.69-6.47h0l-6.76,4.76Z"
                    fill="#fff"
                />
                <path
                    id="Path_225"
                    data-name="Path 225"
                    d="M100.8,203.69s6.18,5,8.27,10.9,5.55,13.69,5.55,13.69H103.11Z"
                    fill="#707272"
                />
                <path
                    id="Path_226"
                    data-name="Path 226"
                    d="M82.44,236.55a2.738,2.738,0,0,1-.31-.37l-.83-1.1-3-4.11c-2.53-3.52-6-8.33-9.77-13.64-.55-.76-1.09-1.52-1.62-2.27l-.07-.1.07-.11,2.56-3.7v.24l-5.69-4.24-.09-.07v-.1l2.45-6.36c.28-.72.52-1.3.69-1.74a3.47,3.47,0,0,1,.27-.6,4.32,4.32,0,0,1-.19.63c-.15.44-.36,1-.62,1.77l-2.32,6.4v-.17l5.72,4.2.14.1-.1.14-2.54,3.71v-.21l1.62,2.27,9.68,13.7,2.9,4.17.77,1.15a2.15,2.15,0,0,1,.28.41Z"
                    fill="#263238"
                />
                <path
                    id="Path_227"
                    data-name="Path 227"
                    d="M81.33,272.33v-1.44c0-1,.06-2.31.11-3.93.11-3.36.26-7.91.43-12.94s.3-9.58.4-12.94l.1-3.92v-1.07a1.82,1.82,0,0,1,0-.37s0,.13,0,.37v4.99c0,3.32-.12,7.9-.29,12.95s-.37,9.63-.55,12.94c-.09,1.62-.17,2.94-.23,3.92,0,.43-.06.78-.08,1.07a1.61,1.61,0,0,1,.11.37Z"
                    fill="#263238"
                />
                <path
                    id="Path_228"
                    data-name="Path 228"
                    d="M83,235.55a1.909,1.909,0,0,1,.12-.39c.12-.29.26-.65.43-1.09l1.63-4,5.51-13.13L92,213.83v.19l-3-3.58-.1-.12.11-.11,4.34-4.5v.13l-1.4-4c-.14-.45-.26-.81-.36-1.1a2.591,2.591,0,0,1-.1-.4,2.337,2.337,0,0,1,.17.37l.43,1.08,1.5,4v.08l-.06.06-4.28,4.55v-.22c1,1.12,2,2.32,3,3.57l.08.08v.11L91,217.08l-5.61,13.09-1.74,4-.5,1.07A1.491,1.491,0,0,1,83,235.55Z"
                    fill="#263238"
                />
                <g id="Group_6" data-name="Group 6" opacity="0.3">
                    <path
                        id="Path_229"
                        data-name="Path 229"
                        d="M63.92,207.03l3.8,4.25-2.62,4.71,16.23,19.26L67.07,214.96l2.56-3.71Z"
                    />
                </g>
                <g id="Group_7" data-name="Group 7" opacity="0.3">
                    <path id="Path_230" data-name="Path 230" d="M83.36,234.64l9.04-17.73-.24-3Z" />
                </g>
                <path
                    id="Path_231"
                    data-name="Path 231"
                    d="M40,256.22a18.282,18.282,0,0,0,1.72.76c1.14.45,2.79,1.1,4.91,1.84,4.24,1.47,10.26,3.39,17.3,5.51l-.22.12c.84-3.13,1.75-6.52,2.7-10l.08.21-.41-.26-12.21-7.74-.11-.07v-.12c1.78-6.13,3.3-11.33,4.38-15l1.27-4.28.36-1.14a2,2,0,0,1,.14-.38,2,2,0,0,1-.09.4c-.07.28-.17.67-.3,1.15l-1.18,4.31c-1.05,3.71-2.52,8.93-4.25,15.07l-.08-.19L66.32,254l.41.26.11.07v.14c-1,3.52-1.87,6.91-2.72,10v.17l-.18-.05c-7-2.14-13-4.11-17.27-5.64-2.11-.77-3.77-1.43-4.89-1.94a10.921,10.921,0,0,1-1.78-.79Z"
                    fill="#263238"
                />
                <path
                    id="Path_232"
                    data-name="Path 232"
                    d="M54.92,207.43a3.386,3.386,0,0,1,.49.31,10.189,10.189,0,0,1,1.2,1.06,14.47,14.47,0,0,1,4.17,9.48,9.63,9.63,0,0,1,0,1.6,1.72,1.72,0,0,1-.1.58c-.07,0,0-.84-.13-2.16a16.31,16.31,0,0,0-1.29-5,16,16,0,0,0-2.8-4.32C55.53,208,54.88,207.48,54.92,207.43Z"
                    fill="#263238"
                />
                <path
                    id="Path_233"
                    data-name="Path 233"
                    d="M102.29,224.73c-.1,0-.45-3.9-.78-8.73s-.51-8.75-.41-8.76.45,3.91.78,8.74S102.39,224.72,102.29,224.73Z"
                    fill="#263238"
                />
                <path
                    id="Path_234"
                    data-name="Path 234"
                    d="M87.91,201.67a3.411,3.411,0,0,1-.39.43c-.26.26-.65.65-1.15,1.13a32.249,32.249,0,0,1-4.51,3.67l-.23.16v-.28A11.93,11.93,0,0,0,81,203a9.81,9.81,0,0,0-.93-1.9,10.453,10.453,0,0,0-.62-.91L79.4,200v-.06h0l.23.05h0a1.331,1.331,0,0,0-.16.17,3.52,3.52,0,0,0-.28.46,13.59,13.59,0,0,0-.9,3.27c-.2,1.09-.37,2.15-.51,3.14v.3l-.23-.18L72,202.8l-1.54-1.26a4.892,4.892,0,0,1-.53-.48,3.141,3.141,0,0,1,.6.39l1.6,1.19,5.55,4.25-.27.12c.14-1,.3-2.06.49-3.16a13.68,13.68,0,0,1,.93-3.38,3.17,3.17,0,0,1,.32-.52,1,1,0,0,1,.23-.23h0l.24.05h0v.06l.09.12c.23.3.44.61.64.93a10.25,10.25,0,0,1,1,2,12,12,0,0,1,.56,3.93l-.24-.13a38.6,38.6,0,0,0,4.55-3.53c.49-.44.9-.79,1.21-1.08S87.89,201.65,87.91,201.67Z"
                    fill="#263238"
                />
                <path
                    id="Path_235"
                    data-name="Path 235"
                    d="M82.42,234.94c-.1,0-.84-7.79-1.65-17.42s-1.39-17.45-1.29-17.46.85,7.79,1.66,17.43S82.52,234.93,82.42,234.94Z"
                    fill="#263238"
                />
                <g id="Group_8" data-name="Group 8" opacity="0.3">
                    <path
                        id="Path_236"
                        data-name="Path 236"
                        d="M59.74,227.26s-.63,16.89-.62,16.93-1.5-10-1.5-10Z"
                    />
                </g>
                <path
                    id="Path_237"
                    data-name="Path 237"
                    d="M72.2,252.94l6.44,7.16h45.1l15-28.76a2.09,2.09,0,0,0-1.85-3.06H92.71a2.08,2.08,0,0,0-1.93,1.29L81.69,251.5,73,251.28a1,1,0,0,0-.8,1.66Z"
                    fill="#565656"
                />
                <path
                    id="Path_238"
                    data-name="Path 238"
                    d="M72.24,251.57a3.32,3.32,0,0,1,.48.44L74,253.32l4.64,4.78h-.26c1.32-2.89,2.89-6.38,4.53-10.14,2.25-5.13,4.21-9.8,5.62-13.19l1.67-4,.47-1.09a2.91,2.91,0,0,1,.18-.37,1.161,1.161,0,0,1-.11.4c-.11.26-.24.66-.4,1.11-.36,1-.89,2.35-1.57,4.06-1.34,3.41-3.26,8.11-5.51,13.24-1.65,3.77-3.24,7.24-4.59,10.12l-.1.21-.16-.16-4.54-4.87-1.26-1.38a3,3,0,0,1-.37-.47Z"
                    fill="#263238"
                />
                <path
                    id="Path_239"
                    data-name="Path 239"
                    d="M110.8,246.32a2.52,2.52,0,1,1,1.48-3.49A2.7,2.7,0,0,1,110.8,246.32Z"
                    fill="#fff"
                />
                <path
                    id="Path_240"
                    data-name="Path 240"
                    d="M66.63,254.94l4.09-.39s7.34-2.44,8.57-2.23a1.82,1.82,0,0,1-.94,2c-1.3.79-3.24,1.73-3.24,1.73L78,259.42a2,2,0,0,0,1.5.68h9.61a2.36,2.36,0,0,1-1.37,1.51c-1,.29-8,2.38-8,2.38l-15.19-1.6Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="10.74"
                    cy="10.74"
                    r="10.74"
                    transform="translate(4.73 300.25)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="6.02"
                    cy="6.02"
                    r="6.02"
                    transform="translate(24.92 352.22)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_241"
                    data-name="Path 241"
                    d="M235.17,90h-9.29V80.75a1.16,1.16,0,0,0-1.16-1.15h0a1.18,1.18,0,0,0-1.18,1.15V90h-9.26a1.17,1.17,0,0,0-1.17,1.18,1.15,1.15,0,0,0,1.17,1.15h9.26v9.3a1.18,1.18,0,0,0,1.18,1.15,1.16,1.16,0,0,0,1.16-1.15h0v-9.3h9.29a1.17,1.17,0,1,0,0-2.33Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_242"
                    data-name="Path 242"
                    d="M508,78.63h-7.66V71a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v7.66h-7.65a1,1,0,0,0,0,1.93h7.65v7.66a1,1,0,0,0,2,0h0V80.56H508a1,1,0,0,0,0-1.93Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <circle
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="8.14"
                    cy="8.14"
                    r="8.14"
                    transform="translate(459.41 278.7)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_243"
                    data-name="Path 243"
                    d="M491.31,356.78h-8.92v-8.91a1.11,1.11,0,0,0-1.11-1.11h0a1.15,1.15,0,0,0-1.14,1.11v8.91h-8.89a1.13,1.13,0,0,0-1.12,1.13,1.11,1.11,0,0,0,1.12,1.11h8.89v8.92a1.14,1.14,0,0,0,1.14,1.11,1.11,1.11,0,0,0,1.11-1.11h0V359h8.92a1.12,1.12,0,1,0,0-2.24Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
